const DataProtectionScreen = () => {

    return(
        <p>Data Protection Screen</p>
    )

}

export default DataProtectionScreen